import PolarisWebBoundary from './components/PolarisWebBoundary';
import SaveSuccessToast from './components/SaveSuccessToast';
import "./App.css";
import Index from "./pages/index";
import AdminEntry from "./components/AdminEntry";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <Router>
      <SaveSuccessToast/><AdminEntry><PolarisWebBoundary><Index /></PolarisWebBoundary></AdminEntry>
    </Router>
  );
}

export default App;
